// @flow
import * as React from 'react'
import { Div, Main } from 'glamorous'
import { DefaultHead, Header, Footer } from 'components'

type Props = {
  data: {
    site: {
      siteMetadata: {
        title: string,
        description: string,
      },
    },
  },
  children: () => React.Node,
}

const DefaultLayout = ({ data, children }: Props) => {
  const { title: pageTitle, description } = data.site.siteMetadata
  return (
    <Div
      css={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        height: '100%',
      }}
    >
      <DefaultHead pageTitle={pageTitle} description={description} />
      <Header title={data.site.siteMetadata.title} />
      <Main flex="1">{children()}</Main>
      <Footer />
    </Div>
  )
}

export default DefaultLayout

export const pageQuery = graphql`
  query LayoutIndexQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`

export const siteUrlFragmentQuery = graphql`
  fragment SiteUrl on RootQueryType {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js